import { Injectable } from '@angular/core';
import { Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { AuthHttpService } from 'app/security/authorization';
import { PaginationList, noop } from 'app/shared';
import { environment } from 'environments/environment';
import { Session, SessionId } from './session.model';
import { SessionMapper } from './session.mapper';
import { UserId } from 'app/user';
import { SessionSurvey } from 'app/session/session-survey.model';
import { SurveyRepository } from 'app/survey/survey.repository';
import { SessionParticipantInfoMapper } from './session-participant-info.mapper';
import { Survey, SurveyId } from 'app/survey';
import { QuestionAdapter } from 'app/question/question.adapter';

@Injectable()
export class SessionRepository {

  constructor(
    private authHttp: AuthHttpService,
    private surveyRepository: SurveyRepository
  ) { }

  public list(params?: URLSearchParams): Observable<PaginationList<Session>> {
    return this.authHttp.get(
        environment.apiUrl + 'session',
        { search: params }
      )
      .map(response => response.json())
      .map(list =>
        new PaginationList<Session>(
            list.items.map(SessionMapper.map),
            list.total
          )
      )
  }

  public getCoachSessions(
    userId: UserId,
    params?: URLSearchParams
  ): Observable<PaginationList<Session>> {
    return this.authHttp.get(
        environment.apiUrl + 'coach/' + userId + '/session',
        { search: params }
      )
      .map(response => response.json())
      .map(list => new PaginationList<Session>(
            list.items.map(SessionMapper.map),
            list.total
          )
      );
  }

  public create(
    name: string,
    surveys: SessionSurvey[],
    coaches: UserId[]
  ): Observable<{ id: SessionId }> {

    return this.authHttp.post(
        environment.apiUrl + 'session',
        {
          name,
          surveys,
          coaches
        }
      )
      .map(response => response.json());
  }

  public update(
    sessionId: SessionId,
    name: string,
    surveys: SessionSurvey[],
    coaches: UserId[]
  ): Observable<{ id: SessionId }> {

    return this.authHttp.put(
        environment.apiUrl + 'session/' + sessionId,
        {
          name,
          surveys,
          coaches
        }
      )
      .map(response => response.json());
  }

  public participants(
    sessionId: SessionId,
    users: UserId[]
  ): Observable<{ id: SessionId }> {

    return this.authHttp.put(
        environment.apiUrl + 'session/' + sessionId + '/participants',
        { users }
      )
      .map(response => response.json());
  }

  public get(sessionId: SessionId): Observable<Session> {
    return this.authHttp.get(
        environment.apiUrl + 'session/' + sessionId
      )
      .map(response => response.json())
      .map(SessionMapper.map);
  }

  public delete(sessionID: SessionId): Observable<any> {
    return this.authHttp.delete(
        environment.apiUrl + 'session/' + sessionID
      )
  }

  public getParticipantSessions(userId: UserId): Observable<PaginationList<Session>> {
    return this.authHttp.get(
        environment.apiUrl + 'participant/' + userId + '/session'
      )
      .map(response => response.json())
      .map(list =>
        new PaginationList<Session>(
            list.items.map(SessionMapper.map),
            list.total
          )
      );
  }

  public confirmSession(sessionId: SessionId) {
    return this.authHttp.patch(environment.apiUrl + 'session/' + sessionId + '/confirm', {});
  }

  public getSessionParticipants(sessionId: SessionId) {
    return this.authHttp.get(
        environment.apiUrl + 'session/' + sessionId + '/participants'
    )
    .map(response => response.json())
    .map(list => list.map(SessionParticipantInfoMapper.map));
  }

  public finishSession(sessionId: SessionId): Observable<any> {
    return this.authHttp.patch(environment.apiUrl + 'session/' + sessionId + '/finish', {});
  }
}



// WEBPACK FOOTER //
// /dist/src/app/session/session.repository.ts